

























import { defineComponent, ref, computed } from '@vue/composition-api';
// @ts-ignore
import { ZybLogin } from '@zyb-login/ui-vue/dist/v2/index.es';
import '@zyb-login/ui-vue/dist/v3/style.css';
import { getEnv, passportHost } from '@/utils/env';
import { zs } from '@zyb-data/stats-h5';
// import { Toast } from '@upc/vant';

export default defineComponent({
  components: {
    ZybLogin
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    loginTitle: {
      type: String,
      default: '手机号登录'
    },
    isLogin: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:show', 'loginSuccess'],
  setup(props: any, { root, emit }: any) {
    console.log('🍎🍎------：props', props, root, ref);
    const viewConfig = ref({
      mLogin: {
        submitButton: {
          text: props.isLogin ? '登录' : '注册'
        }
      }
    });

    const visible = computed({
      get() {
        props.show && !props.isLogin && zs.track('CJ1_069', {});
        return props.show;
      },
      set(v: boolean) {
        emit('update:show', v);
      }
    });
    const close = () => {
      !props.isLogin && zs.track('CJ1_070', {});
      visible.value = false;
    };

    const handleOpenUser = () => {
      window.open('https://www.daxuesoutijiang.com/static/hy/dx-app/serviceProtocol.html', '_blank');
    };

    const handleOpenPrivacy = () => {
      window.open('https://www.daxuesoutijiang.com/static/hy/dx-app/privacyProtocol.html', '_blank');
    };

    const env = getEnv();
    // console.log('env', env)
    const sdkConfig = ref({
      appId: 'college',
      baseUrl: passportHost(props.isLogin),
      fr: 'dx_pc_extension',
      env,
      extraParams: {
        samesite: 1
      }
    });
    const handleLogin = (res: any) => {
      console.log('handleLogin----------', res);
      if (res.errNo === 0 && res.data.dxuss) {
        close();
        emit('loginSuccess', res.data.dxuss);
      } else {
        console.log('handleLogin----------', res);
      }
    };

    return {
      viewConfig,
      handleOpenUser,
      handleOpenPrivacy,
      sdkConfig,
      handleLogin,
      visible,
      close
    };
  }
});
